<template>
  <!-- 盒子排除 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      title="盒子排除"
      width="800px"
      @close="closeDialog"
    >
      <div class="set-box">
        <el-form :model="query" :inline="true" label-width="80px">
          <el-form-item>
            <el-input
              style="width: 130px"
              v-model="query.name"
              placeholder="请输入盒子名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              style="width: 140px"
              v-model="query.category_id"
              placeholder="请选择盒子分类"
            >
              <el-option :value="undefined" label="请选择盒子分类"
                >全部</el-option
              >
              <el-option
                v-for="item in categories"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              style="width: 140px"
              v-model="query.box_group_id"
              placeholder="请选择盒子分组"
            >
              <el-option :value="undefined" label="请选择盒子分组"
                >全部</el-option
              >
              <el-option
                v-for="item in boxGroupList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              style="width: 130px"
              v-model="query.status"
              placeholder="盒子状态"
            >
              <el-option :value="undefined" label="请选择状态">全部</el-option>
              <el-option :value="1" label="正常"></el-option>
              <el-option :value="2" label="关闭"></el-option>
              <el-option :value="3" label="补货中"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              style="width: 100px"
              v-model="query.type"
              placeholder="是否包含"
            >
              <el-option :value="undefined" label="是否包含">全部</el-option>
              <el-option :value="2" label="是"></el-option>
              <el-option :value="1" label="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getData()"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="setAllBox(0)"
              >全部排除</el-button
            >
            <el-button type="primary" size="small" @click="setAllBox(1)"
              >全部包含</el-button
            >
          </el-form-item>
        </el-form>

        <el-table class="box-table" :data="dataList" v-loading="loading">
          <el-table-column prop="id" label="盒子ID" align="center">
          </el-table-column>
          <el-table-column prop="name" label="盒子名称" align="center">
          </el-table-column>
          <el-table-column label="盒子图片" align="center">
            <template slot-scope="{ row }">
              <img style="width: 50px" :src="row.image" alt />
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
          <el-table-column label="盒子状态" align="center">
            <template slot-scope="{ row }">
              <el-tag type="primary" v-if="row.status === 1">正常</el-tag>
              <el-tag type="danger" v-if="row.status === 2">关闭</el-tag>
              <el-tag type="info" v-if="row.status === 3">补货中</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否包含" align="center">
            <template slot-scope="{ row }">
              <el-button
                type="success"
                size="small"
                @click="changeBox(row, 0)"
                v-if="row.debris_collects && row.debris_collects.length"
                
                >是</el-button
              >
              <el-button
                type="danger"
                size="small"
                @click="changeBox(row, 1)"
                v-else
                >否</el-button
              >              
            </template>
          </el-table-column>
        </el-table>

        <!-- 底部分页条 -->
        <el-pagination
          background
          :page-size="dataMeta.per_page || 15"
          :total="dataMeta.total || 0"
          :current-page="dataMeta.current_page"
          @current-change="handlePageChange"
          v-if="dataMeta && dataMeta.total > dataMeta.per_page"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  mapActions,
  mapMutations,
  mapState,
  mapGetters
} from 'vuex'
import {
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '../../http'
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: undefined
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false, //弹窗加载动画
      buttonLoading: false, //按钮加载动画
      query: {
        page: 1,
        name: undefined, //盒子名称
        category_id: undefined, //分类id
        box_group_id: undefined, //分组id
        status: undefined, //盒子状态
        type: undefined,//是否包含
      },
      dataList: undefined,//盒子数据列表
      user_id: undefined, //用户id
      userList: undefined, //用户列表
      dataMeta: undefined,//底部分页数据
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    }),
    ...mapGetters(['boxGroupList']),
    showMark: { //显示标志
      get() {
        return this.visible
      },
      set() { }
    },
    controlInfo: { //传来的数据
      get() {
        return this.value
      },
      set() { }
    },
  },
  watch: {
    showMark(val) {
      if (val) {
        this.getData()
      }

    }
  },
  created() {
    !this.categories && this.getCategories() //盒子分类
    this.getBoxGroupList() //盒子分组
  },
  methods: {
    ...mapActions(['getCaseList', 'getCategories', 'getBoxGroupList']),
    getData(num) {
      //查询盒子列表
      if (num != 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData(`debris/boxes/${this.controlInfo.id}`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    setAllBox(num) {
      // 修改全部盒子包含状态
      this.buttonLoading = true
      let params = {
        status: num,
        query: this.query
      }
      patchApiData(`debris/boxes/${this.controlInfo.id}`, params)
        .then(res => {
          this.$message.success("修改成功！")
          this.getData()
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    changeBox(rowInfo, num) {
      // 修改包含状态
      let params = {
        box_id: rowInfo.id,
        status: num
      }
      patchApiData(`debris/boxes/${this.controlInfo.id}`, params)
        .then(res => {
          this.$message.success("修改成功！")
          this.getData()
        })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData(1);
    },
    closeDialog() {
      //关闭弹窗
      this.$emit('close')
    },
  }
}

</script>
<style lang="less" scoped>
.set-box {
  .box-table {
    max-height: 400px;
    overflow-y: auto;
  }
}
</style>
